const Form040SC = {
    stepName: {
        importantNotes: "重要事项",
        basicInformation: "基本资料",
        maximumCapacity: "最高容额",
        childrenServed: "服务儿童年岁",
        currentStaffStrength: "现时员工编制",
        existingFacilities: "现有设施",
        confirmation: "确认",
    },

    importantNotes: {
        p_title: "个人资料收集声明 ",
        p1_1: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途︰",
        p1_a: "进行核数工作；",
        p1_b: "进行研究及统计资料，以便规划学前教育服务；",
        p1_c: "处理有关学前教育专业人员发展的事宜；",
        p1_d: "处理有关学前教育机构的营运事宜；",
        p1_e: "执行《教育条例》、《教育规例》、《幼儿服务条例》(第243章) 及《幼儿服务规例》(第243A章)。",

        p2: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        p3: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        p4: "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        p5: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
    },

    childrenAgeOption: {
        zeroThreeYears: "零至三岁",
        twoThreeYearsStepThree: "二至三岁",
        zeroSixYears: "零至六岁",
        twoSixYearsStepThree: "二至六岁",
    },
    workingHoursOption: {
        AmAndPm: "AM+PM",
        Am: "AM",
        Pm: "PM",
        Other: "其他工作时间",
    },
    FirstAidTrainingOption: {
        yes: "是",
        no: "否",
    },
    operatorTypeOption: {
        operator: "经营人",
        centreSupervisor: "中心主管",
        kindergartenPrincipal: "幼稚园校长",
    },
    label: {
        applicantAddress: "申请人地址",
        nameOfKgCumCcc: "幼稚园暨幼儿中心名称",
        addressOfKgCumCcc: "幼稚园暨幼儿中心地址",

        maximumCapacity: "（甲）（i）最高容额",
        existingApprovedCapacity: "（ii）现时批核容额",
        proposedCapacityAfterAdjustment: "（iii）建议调整容额",
        childrenServed: "（乙）服务儿童年岁（单选）",
        zeroTwoYears: "最高容额（零至二岁）",
        twoThreeYears: "最高容额（二至三岁）",
        twoSixYears: "最高容额（二至六岁）",

        currentStaffStrength: "（丙）现时员工编制",
        zeroThreeYears: "（i）零至三岁",
        twoThreeYearsStepThree: "（ii）二至三岁",
        zeroSixYears: "（iii）零至六岁",
        twoSixYearsStepThree: "（iv）二至六岁",

        proposedCapacityAfterAdjustmentWef: "建议調整容额生效日期",

        name: "姓名",
        hKid: "香港身份证号码",
        passport: "护照号码",
        hkidOrPassport: "香港身份证号码／护照号码",
        post: "职位",
        ccsInclusion: "幼儿工作主任编号",
        ccwInclusion: "幼儿工作员编号",
        ccsOrCCwInclusion: "幼儿工作主任编号／幼儿工作员编号",
        rtNo: "检定教员编号",
        ptNo: "准用教员编号",
        rtptNoType: "检定教员编号／准用教员编号",
        workingHours: "工作时间",
        otherWorkingHours: "请注明",
        firstAidCertNo: "有效急救证书编号",
        firstAidCertValidDate: "急救训练证书生效日期",
        firstAidCertExpireDate: "急救训练证书届满日期",
        firstAidTraining: "曾接受急救训练",
        attachment: "附件（急救证书）",

        existingFacilities: "（丁）现有设施",

        toiletPans: "（i）儿童厕盆的数目",
        washBasins: "（ii）儿童洗手盆的数目",
        urinalTroughs: "（iii）尿槽／尿盆的數目（尿槽长度不可少于450毫米）",
        tips: "用“/”隔开这两个数字",

        remarks:
            "本人明白需要僱用足够的幼儿工作员／教学人员和提供充分的设备以符合幼儿服务规例、学前机构办学手册及教育规例的要求。",
        Remarks: "（戊）注意事项",
        operatorType: "经营人／中心主管／幼稚园校长",
        operatorName: "{{type}} 姓名",
        telNo: "电话号码",
        statement:
            "本人现申请调整上述幼稚园暨幼儿中心之幼儿中心（部份）容额，详情如下：",
    },
    table: {
        ageRange: "年龄范围",
        fullDay: "全日",
        am: "上午",
        pm: "下午",
        existingZeroTwoYears: "零至二岁",
        existingTwoThreeYears: "二至三岁",
        existingTwoSixYears: "二至六岁",
        proposedZeroTwoYears: "零至二岁",
        proposedTwoThreeYears: "二至三岁",
        proposedTwoSixYears: "二至六岁",
        tooltip0To999: "0-999",
    },
    errorMsg: {
        specify: "注明",
        E0015: "儿童厕盆的数目必填",
        E0016: "儿童洗手盆的数目必填",
        E0017: "尿槽/尿盆的数目必填",
        E0018: "请勾选",

        E0026: "（i）, （ii） 和 （iii）总数必须大于0",
        E0027: "最大长度不能超过1000",
        E0028: "最大长度不能超过200",
        E0029: "最高容额总数必须大于0",
        E0031: "格式不正确",
        E0032: "香港身份证号码和护照号码必须填其中一个",
        E0033: "幼儿工作主任编号和幼儿工作员编号必须填其中一个",
        E0034: "每项最小值为0，最大值为99",
        afterToday: "急救证书届满日期必须在今天之后",
        isExistingMsgEmpty: "如最高容額為空, 同年齡範圍的現批容額都要為空",
        isProposedMsgEmpty: "如最高容額為空, 同年齡範圍的建議調整容額都要為空",
    },
    submittedDialog: {
        text1: "你已成功送出表格。請注意表格尚未提交至教育局。表格正在等待{{status}}審批。",
    },
};
export default Form040SC;
